var _a;
import { BlendMode } from '../image';
import { ContextGLVertexBufferFormat } from '../base/ContextGLVertexBufferFormat';
import { ContextGLBlendFactor as BF } from '../base/ContextGLBlendFactor';
import { ContextGLTriangleFace } from '../base/ContextGLTriangleFace';
import { ContextGLDrawMode } from '../base/ContextGLDrawMode';
var VERTEX = "\nprecision highp float;\n\n/* AGAL legacy atrib resolver require this names */\nattribute vec4 va0; // position\nattribute vec4 va1; // posMatrix\nattribute vec4 va2; // uvMatrix\nattribute float va3; // SamplerId\n\nvarying vec2 vUv;\nvarying float vId;\n\nvoid main() {\n\tvec4 pos = va0;\n\t\n\tpos.xy = pos.xy * va1.zw + va1.xy;\n\tpos.z = pos.z * 2.0 - pos.w;\n\n\tvUv = va0.xy * va2.zw + va2.xy;\n\tvId = va3;\n\tgl_Position = pos;\n}";
function emitSamplerBlocks(count) {
    var blocks = [];
    for (var i = 0; i < count; i++) {
        if (i === 0) {
            blocks.push("\tif (vId < " + (i + 0.5).toFixed(1) + ")\n\t\t\t\t\t\tgl_FragColor = texture2D(uTex[" + (i | 0) + "], vUv);\n\t\t\t\t");
        }
        else {
            blocks.push("\telse if (vId < " + (i + 0.5).toFixed(1) + ")\n\t\t\t\t\t\tgl_FragColor = texture2D(uTex[" + (i | 0) + "], vUv);\n\t\t\t\t");
        }
    }
    blocks.push('	else gl_FragColor = vec4(1.0, 0.0, 1.0, 0.0);');
    return blocks.join('\n');
}
var FRAG = function (samplers) {
    if (samplers === void 0) { samplers = 1; }
    return "\nprecision highp float;\nuniform sampler2D uTex[" + samplers + "];\n\nvarying vec2 vUv;\nvarying float vId;\n\nvoid main() {\n\t" + emitSamplerBlocks(samplers) + "\n}";
};
var DEFAULT_BLEND_MAP = (_a = {},
    _a[''] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.NORMAL] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.LAYER] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.ERASE] = [BF.ZERO, BF.ONE_MINUS_SOURCE_ALPHA],
    _a);
var CopyFilterInstanced = /** @class */ (function () {
    function CopyFilterInstanced(manager) {
        this._samplerIds = Array.from({ length: CopyFilterInstanced.SAMPLERS_LIMIT }, function (e) { return 0; });
        this._instanceData = new Float32Array(CopyFilterInstanced.TASKS_LIMIT * CopyFilterInstanced.DATA_COUNT);
        this._instanceView = this._instanceData;
        this._copyTasks = [];
        this._images = [];
        this._blendDst = BF.ONE_MINUS_SOURCE_ALPHA;
        this._blendSrc = BF.ONE;
        this._requireBlend = true;
        this._blend = '';
        this._mustBeFlushed = false;
        this._manager = manager;
        this._stage = manager.stage;
    }
    Object.defineProperty(CopyFilterInstanced.prototype, "blendDst", {
        get: function () {
            return this._blendDst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "blendSrc", {
        get: function () {
            return this._blendSrc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "requireBlend", {
        get: function () {
            return this._requireBlend;
        },
        set: function (v) {
            if (!this._requireBlend && v) {
                this.blend = '';
            }
            this._requireBlend = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "blend", {
        get: function () {
            return this._blend;
        },
        set: function (v) {
            var map = DEFAULT_BLEND_MAP[v];
            this._requireBlend = !!map;
            if (map) {
                this._blendDst = map[1];
                this._blendSrc = map[0];
            }
            else {
                // go composite by shader
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "mustBeFlushed", {
        get: function () {
            return this._mustBeFlushed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "prog", {
        get: function () {
            if (!this._prog) {
                this._prog = this._stage.context.createProgram();
                this._prog.name = 'CopyShaderInstanced:' + CopyFilterInstanced.SAMPLERS_LIMIT;
                this._prog.uploadRaw(VERTEX, FRAG(CopyFilterInstanced.SAMPLERS_LIMIT));
            }
            return this._prog;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "length", {
        get: function () {
            return this._copyTasks.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyFilterInstanced.prototype, "target", {
        get: function () {
            return this._target;
        },
        set: function (image) {
            this._target = image;
        },
        enumerable: false,
        configurable: true
    });
    CopyFilterInstanced.prototype.addCopyTask = function (from, to, source) {
        var samplerID = this._images.indexOf(source);
        if (samplerID === -1) {
            samplerID = this._images.length;
            this._images.push(source);
        }
        this._copyTasks.push({
            from: from.clone(),
            to: to.clone(),
            source: source,
            samplerID: samplerID
        });
        if (this._images.length === CopyFilterInstanced.SAMPLERS_LIMIT ||
            this._copyTasks.length === CopyFilterInstanced.TASKS_LIMIT) {
            this._mustBeFlushed = true;
            //this.flush();
        }
    };
    CopyFilterInstanced.prototype.fillInstancesBuffer = function (offset, task) {
        var data = this._instanceView;
        var dest = task.to;
        var input = task.from;
        var target = this._target;
        var source = task.source;
        if (dest.width * dest.height === 0) {
            dest.width = input.width;
            dest.height = input.height;
        }
        offset *= 9;
        // pos = scale * pos + offset
        // pos in viewport MUST be -1 - 0, for this we multiple at 2 and decrease 1
        // pos offset (-1, 1)
        data[0 + offset] = 2. * dest.x / target.width - 1;
        data[1 + offset] = 2. * dest.y / target.height - 1;
        // pos scale
        data[2 + offset] = 2. * dest.width / target.width;
        data[3 + offset] = 2. * dest.height / target.height;
        // uv already from 0,1, not require remap it
        // uv offset
        data[4 + offset] = input.x / source.width;
        data[5 + offset] = input.y / source.height;
        // uv scale
        data[6 + offset] = input.width / source.width;
        data[7 + offset] = input.height / source.height;
        // sampler
        data[8 + offset] = task.samplerID;
    };
    CopyFilterInstanced.prototype.activateElements = function () {
        var context = this._stage.context;
        if (!this._vertexBuffer) {
            this._vertexBuffer = context.createVertexBuffer(6, 8);
            this._vertexBuffer.uploadFromArray(new Float32Array([
                0, 0,
                1, 1,
                1, 0,
                0, 0,
                0, 1,
                1, 1
            ]), 0, 6);
            this._instanceBuffer = context.createVertexBuffer(CopyFilterInstanced.TASKS_LIMIT, CopyFilterInstanced.DATA_COUNT * 4);
            this._instanceBuffer.initAsDynamic(CopyFilterInstanced.TASKS_LIMIT);
            this._instanceBuffer.instanced = true;
            this._instanceBuffer.dynamic = true;
        }
        if (!this._vao) {
            this._vao = context.hasVao ? context.createVao() : null;
            this._vao && this._vao.bind();
            // pos
            context.setVertexBufferAt(0, this._vertexBuffer, 0, ContextGLVertexBufferFormat.FLOAT_2);
            // instancing
            // posMatrix
            context.setVertexBufferAt(1, this._instanceBuffer, 0, ContextGLVertexBufferFormat.FLOAT_4);
            // uvMatrix
            context.setVertexBufferAt(2, this._instanceBuffer, 4 * 4, ContextGLVertexBufferFormat.FLOAT_4);
            // samplerId
            context.setVertexBufferAt(3, this._instanceBuffer, 4 * 4 * 2, ContextGLVertexBufferFormat.FLOAT_1);
        }
        else {
            this._vao.bind();
        }
        this._instanceBuffer.uploadFromArray(this._instanceView);
    };
    CopyFilterInstanced.prototype.deactivateElements = function () {
        this._vao && this._vao.unbind();
    };
    CopyFilterInstanced.prototype.prepareTask = function () {
        var tasks = this._copyTasks;
        var len = tasks.length;
        if (len !== this._instanceView.length / 9) {
            // create new VIEW to fill sub data
            this._instanceView = new Float32Array(this._instanceData.buffer, 0, 9 * len);
        }
        // Fill instanced buffer data
        for (var i = 0; i < len; i++) {
            this.fillInstancesBuffer(i, tasks[i]);
        }
        var images = this._images;
        var imLen = images.length;
        // Bind textures to slots
        for (var i = 0; i < imLen; i++) {
            images[i].getAbstraction(this._stage).activate(i);
            this._samplerIds[i] = i;
        }
        this._prog.uploadUniform('uTex', this._samplerIds);
    };
    CopyFilterInstanced.prototype.flush = function () {
        if (this._copyTasks.length === 0) {
            return;
        }
        var stage = this._stage;
        var context = stage.context;
        // now we run instanced renderer until `drawVertices`
        context.beginInstancedRender(this._copyTasks.length);
        stage.setRenderTarget(this._target, false, 0, 0, true);
        context.setBlendFactors(this._blendSrc, this._blendDst);
        context.setBlendState(!!this.requireBlend);
        context.setCulling(ContextGLTriangleFace.NONE);
        //context.disableDepth();
        //context.disableStencil();
        context.setProgram(this.prog);
        this.prepareTask();
        this.activateElements();
        // run instanced
        context.drawVertices(ContextGLDrawMode.TRIANGLES, 0, 6);
        this.deactivateElements();
        this._target = null;
        this._mustBeFlushed = false;
        this._images.length = 0;
        this._copyTasks.length = 0;
    };
    CopyFilterInstanced.DATA_COUNT = 9; // 4 - posMatrix, 4 - texMatrix, 1 - texId
    CopyFilterInstanced.SAMPLERS_LIMIT = 16;
    CopyFilterInstanced.TASKS_LIMIT = 100;
    return CopyFilterInstanced;
}());
export { CopyFilterInstanced };
